import { post, get, put, del } from '@api/request';

export async function searchBuilderPlans(
  { appraisalService },
  authenticationToken,
  { payload, page = 1, pageSize = 50 },
) {
  let url = `${appraisalService}/appraisal/builderplan/search`;
  if (page && pageSize) {
    url += `?page=${page}&pageSize=${pageSize}`;
  }
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchSearchConfigsForBuilderPlan(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/builderplansearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBuilderNames(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Builder Plans&name=Builder Name`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertBuilderPlan(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/builderplans`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchBuilderPlan(
  { appraisalService },
  authenticationToken,
  { builderPlanId },
) {
  const url = `${appraisalService}/appraisal/builderplan/${builderPlanId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateBuilderPlan(
  { appraisalService },
  authenticationToken,
  { builderPlanId, payload },
) {
  const url = `${appraisalService}/appraisal/builderplan/${builderPlanId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchBuilderPlanSketch(
  { appraisalService },
  authenticationToken,
  { builderPlanId },
) {
  const url = `${appraisalService}/appraisal/builderplan/${builderPlanId}/sketches`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function copyCostApproachFromValuation(
  { appraisalService },
  authenticationToken,
  { valuationId, payload },
) {
  const url = `${appraisalService}/appraisal/valuation/${valuationId}/copycostapproach`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchBuilderPlanValuation(
  { appraisalService },
  authenticationToken,
  { builderPlanId },
) {
  const url = `${appraisalService}/appraisal/builderplan/${builderPlanId}/valuation`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteBuilderPlan(
  { appraisalService },
  authenticationToken,
  { builderPlanID },
) {
  const url = `${appraisalService}/appraisal/builderplan/${builderPlanID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
